import React from "react";
import {useFormik} from "formik";

import {useFeedbackTools} from "../../../components/FeedbackTools";
import {ResponsiveStepperDialog} from "../../../components/ResponsiveStepperDialog";
import {useAccommodationsPage} from "../AccommodationContext";
import StepContact from "./StepContact";
import StepAddress from "./StepAddress";
import {stepAddressSchema, stepContactSchema} from "./stepValidationSchema";


const steps = ['Indirizzo', 'Contatto'];
const stepValidations = [stepAddressSchema, stepContactSchema];

const FormCreateHome = () => {
    const {createHome, formCreateHome, onHomeSelection} = useAccommodationsPage();

    const [isSaving, setIsSaving] = React.useState(false);
    const [activeStep, setActiveStep] = React.useState(0);
    const isLastStep = activeStep === steps.length - 1;
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const formik = useFormik({
        initialValues: {
            name: "",
            locationId: "",
            addressStreet: "",
            addressNumber: "",
            addressCity: "",
            mail: "",
            phone: "",
            mobilePhone: "",
        },
        validationSchema: stepValidations[activeStep],
        validateOnMount: true,

        onSubmit: async (values, actions) => {
            if (isLastStep) {
                setIsSaving(true);
                try {
                    const home = await createHome(values);
                    showSuccessNotification('Casa creata');
                    formCreateHome.close();
                    onHomeSelection(home);
                } catch (e) {
                    showErrorNotification(e);
                    setIsSaving(false);
                }
            }
            else {
                setActiveStep(activeStep + 1);
                actions.setTouched({});
                actions.setSubmitting(false);
            }
        },
    });

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const getStepContent = () => {
        switch (activeStep) {
            case 0:
                return <StepAddress formik={formik}/>;
            case 1:
                return <StepContact formik={formik}/>;
            default:
                throw new Error('Unknown step');
        }
    };

    const disableSave = Object.keys(formik.errors).some(x => formik.touched[x]);

    return <ResponsiveStepperDialog title="Nuova Casa"
                                    isOpen={true}
                                    steps={steps}
                                    activeStep={activeStep}
                                    isSaving={isSaving}
                                    enableSubmit={!disableSave}
                                    onClose={formCreateHome.close}
                                    onBack={handleBack}
                                    onSubmit={formik.handleSubmit}
                                    disableBackdropClose
                                    noValidate>
        {getStepContent()}
    </ResponsiveStepperDialog>
}

export default FormCreateHome;